import React, {useMemo, useState} from 'react'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import { Container, Row, Col, ModalFooter } from 'react-bootstrap';
import Button from '../../../components/Button';
import Accordion from '../../../components/Accordion';
import AccordionBodyItem from '../../../components/Accordion/AccordionBodyItem';
import { getAllBenefitsLibrary } from '../../../services/enrollment';

export type customBenefitsLibraryProps = {
    showBenefitsLibrary: boolean;
    handleCloseBenefitsLibrary: () => void;
  };

const BenefitsLibrary = ({
    showBenefitsLibrary,
    handleCloseBenefitsLibrary,
  }: customBenefitsLibraryProps) => {

    const [activeAccordion, setActiveAccordion] = useState<string | undefined>(undefined);

    const dataBenefits = useMemo(() => {
      return getAllBenefitsLibrary();
    }, []);

  return (
    <Modal
      show={showBenefitsLibrary}
      onHide={handleCloseBenefitsLibrary}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefits Library</h4>
      </ModalHeader>
      <ModalBody>
  <Row className="mt-4">
    
    {Object.entries(dataBenefits).map(([categoryName, items], index) => (
      <Accordion 
        key={String(index)}
        title={categoryName} 
        className={'my-4'}
      >
        {items.map((item, itemIndex) => (
          <Container key={itemIndex} className="custom-accordion-demo">
            <Row className="m-0 body-rows">
              <Col className={`p-0 col-12 d-flex flex-column justify-content-center`}>
                <a
                  className="text-decoration-none link-dark"
                  href={item.type === 'PDF' && item.file ? `${process.env.PUBLIC_URL}/${item.file}` : (item.type === 'WEB' && item.url ? item.url : '#')}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    if ((item.type === 'PDF' && !item.file) || (item.type === 'WEB' && !item.url)) {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="d-flex justify-content-between w-100">
                    <span className="pe-3 ben-title">{item.name}</span>
                    <div className="ben-link ms-auto d-flex align-items-center">
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={item.type === 'PDF' ? light('file-pdf') : light('globe')}
                      />
                      <span className="ms-2">{item.type}</span>
                    </div>
                  </div>
                </a>
              </Col>
            </Row>
          </Container>
        ))}
      </Accordion>
    ))}
  </Row>
</ModalBody>

      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseBenefitsLibrary}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default BenefitsLibrary